import React, { Component } from "react"
import DiagnoseProblemCard from "./DiagnoseProblemCard"
import { getSubdomain } from "../../../v1/components/Config/StylesheetInjector"
import {
  GRUBHUB,
  INSTACART,
  INSTACART_CA,
  SHIPT,
  UBER,
  UBER_CANADA,
  USAA
} from "../../../v1/constants/affiliations"
import BuyNewTireCard from "./NewTireCard"
import { nextMembershipUpgrades } from "../../../v1/helpers/membershipHelpers"
import { connect } from "react-redux"
import MilesEarnedCard from "../Rewards/MilesEarnedCard"
import { getSplitIOForFeatures } from "../../../v1/actions/user"
import { TIRE } from "../../../v1/constants/offers"
import { getPartnerFeatureFlag } from "../../../shared_component/utils/partnerFeatureFlag"
import UpgradeMembershipCard from "./UpgradeMembershipCard"
import { BASIC } from "../../../v1/constants/membershipPanel"
import AffilationCards from "./AffilationCards"
import SplitClient, { ON, REWARDS } from "../../../v1/components/Config/SplitClient"
import { APP_NAME } from "../../../shared_component/constants/common"

const subDomain = getSubdomain()
class DashBoardCards extends Component {
  constructor(props) {
    super(props)
    this.state = {
      tiresResponse: {},
      partnersOffersFlag: null,
      isRewardsFeature: null
    }
  }
  async componentDidMount() {
    const { user, getSplitIOForFeatures } = this.props
    const responseTires = await getSplitIOForFeatures(TIRE)

    const isRewardsFeatureEnable = await SplitClient.getTreatments([REWARDS], this.props.user, {
      app_name: APP_NAME
    })

    const result = await getPartnerFeatureFlag(user)
    this.setState({
      tiresResponse: responseTires && responseTires.result,
      isRewardsFeature: isRewardsFeatureEnable[REWARDS] === ON
    })

    if (result) {
      this.setState({
        partnersOffersFlag: result
      })
    }
  }

  render() {
    const { accountTierName, user, isTireCard } = this.props
    const { tiresResponse, partnersOffersFlag, isRewardsFeature } = this.state
    const { affiliation } = user
    const initialCards = []
    if (isTireCard && partnersOffersFlag && tiresResponse && tiresResponse.tireconnect) {
      initialCards.push(<BuyNewTireCard />)
    }
    let cards = [...initialCards]
    if (accountTierName === BASIC && !isTireCard) {
      cards = [<UpgradeMembershipCard />, ...cards]
    }
    if (isRewardsFeature && !isTireCard) {
      cards = [
        <div className="miles-card">
          <MilesEarnedCard />
        </div>,
        ...cards
      ]
    }
    // cards = [...cards, <DiagnoseProblemCard />]
    const validSubdomains = [UBER, UBER_CANADA, INSTACART, INSTACART_CA, SHIPT, USAA, GRUBHUB]
    if (
      validSubdomains.includes(subDomain) &&
      affiliation &&
      affiliation.displays_affiliation_to_customer
    ) {
      cards.splice(2, 0, <AffilationCards />)
    }
    return (
      <div className="dashboard-cards-section">
        {cards &&
          cards
            .splice(0, 3)
            .map((card, index) => <React.Fragment key={index}>{card}</React.Fragment>)}
      </div>
    )
  }
}

function mapStateToProps(state, props) {
  let user = state.user || {}
  let { membershipData } = state
  let cart
  let isCart
  let currentActiveOrder =
    user.active_orders && user.active_orders.find((o) => o.vehicle_id == user.activeVehicleId)
  let activeVehicle = user.vehicles && user.vehicles.find((v) => v.id == user.activeVehicleId)
  let activeOrder =
    activeVehicle &&
    activeVehicle.id &&
    (user.active_orders || []).find((o) => o.vehicle_id === activeVehicle.id)

  if (currentActiveOrder) {
    cart = currentActiveOrder
    isCart = false
  } else {
    isCart = true

    if (props.cartId) {
      cart = user.active_carts && user.active_carts.filter((c) => c.id == Number(props.cartId))[0]
    } else {
      cart =
        user.active_carts && user.active_carts.find((c) => c.vehicle_id == user.activeVehicleId)
    }
  }

  if (!cart || !cart.order_services) {
    cart = { estimated_total: 0, order_services: [] }
  }

  return {
    isCart: isCart,
    cart: cart,
    user: user,
    activeVehicle,
    activeOrder,
    orderLoading: state.orders.loading,
    nextUpgrades: nextMembershipUpgrades(user, membershipData.availableMembershipPlans),
    accountTierName: user.membership && user.membership.plan_name
  }
}

export default connect(mapStateToProps, { getSplitIOForFeatures, getPartnerFeatureFlag })(
  DashBoardCards
)
